import FooterControl from '@/components/FooterControl.vue';
import { GENDER_OPTOINS, ORDER_TYPE_OPTION } from '@/config/constant';
import { BigNumber } from 'bignumber.js';
import { cloneDeep } from 'lodash';

const BN = BigNumber.clone();
BN.config({ DECIMAL_PLACES: 2 });
const isChecked = item => item.parentChecked;
const isCheckedChild = item => item.checked;

export default {
  name: 'sale-drug',
  components: { FooterControl },
  data() {
    return {
      tableData: [],
      patient: {
        patientName: '--',
        genderStr: '--',
        age: '-',
        ageType: '-',
      },
      orderType: '',
      fee: {},
      records: [],
      inquiryInfo: {},
      orderPrescriptionList: [], // 处方数组
      salePrescription: [], // 直接售药
      wPrescription: [], // 西药处方
      ePrescription: [], // 中药处方
      infusionPrescription: [], // 输液卡处方
      applyPrescription: [], // 贴敷
      orderBalance: {
        alipayAmt: 0, // 支付宝支付
        cashAmt: 0, // 现金
        commercialInsurance: 0, // 商业保险支付
        medicalInsurance: 0, // 医保支付
        otherAmt: 0, // 其他支付
        posAmt: 0, // 银行卡支付
        remainingAmt: 0, // 余额支付
        wechatAmt: 0, // 微信支付
        wechatAppsAmt: 0, // 微信小程序支付
        wechatPayAmt: 0, // 微信当面付
        debtAmt: 0, // 欠费
        refundAmt: 0, // 欠费抵扣
      }, // 订单结算方式
      orderExamList: [], // 检查项
      orderAdditionList: [], // 附加费用
      num4: 1,
      centerDialogVisible: false,
      checked: true,
      isAllOffer: false, // 是否为order全订单优惠
      checkDisabled: false,
      payOptions: [
        {
          value: '1',
          label: '现金',
        },
        {
          value: '3',
          label: '微信',
        },
        {
          value: '2',
          label: '支付宝',
        },
        {
          value: '4',
          label: '银行卡',
        },
        {
          value: '5',
          label: '其他',
        },
      ],
      req: {
        payMode: '1', // 默认使用现金
      }, // 请求参数
      comfirmDisabled: false, // 退费防重复提交
      recordVersion: '', // 订单号版本
      inputAmt: '',
      payModeHistory: '1', // 历史选择记录
      payMode: ['1'],
      ageString: '', // 年龄
    };
  },

  methods: {
    payModeChange(val) {
      if (val.length === 0) {
        this.req.payMode = this.req.payMode.push('1');
        return;
      }
      if (val.length === 2) {
        const indexHis = this.payMode.findIndex(item => item === this.payModeHistory);
        this.payMode.splice(indexHis, 1);
        [this.payModeHistory] = this.payMode;
      }
    },
    numberHandleChange(val, scriptType, item, index, idx) {
      if (val === 0) {
        this[scriptType][index].items[idx].checked = false;
        this.checkHandle(scriptType, false, index);
      } else {
        this[scriptType][index].items[idx].checked = true;
        this.checkHandle(scriptType, true, index);
      }
      this.resetInputAmt();
    },
    getFeeDetail() {
      const { id } = this.$route.query;
      // 初始化checked 和退货数量
      const initChecked = (item) => {
        const script = cloneDeep(item);
        script.parentChecked = false; // 初始化checked
        script.items = item.items.map((it) => {
          // it.dosage 输入的数量  - it.refundedCount 已退的数量
          const count = it.dosage - it.refundedCount;
          return {
            ...it,
            maxCount: count, // 可退货数量
            count: 0, // 退货数量
            checked: false, // 初始化checked
          };
        });
        return script;
      };
      // 初始化checked 和退货数量
      const init = (item) => {
        const script = cloneDeep(item);
        script.parentChecked = false; // 初始化checked
        script.items = item.items.map((it) => {
          // it.dosage 输入的数量  - it.refundedCount 已退的数量
          const count = it.dosage - it.refundedCount;
          return {
            ...it,
            maxCount: count, // 可退货数量
            count, // 退货数量
            checked: false, // 初始化checked
          };
        });
        return script;
      };

      // 过滤类型
      this.$api.feeDispense.completedDetail({ id }).then((res) => {
        if (res.orderType === 1) {
          this.ageString = res.inquiryInfo.clinicalAge ? res.inquiryInfo.clinicalAge : '--';
        } else {
          this.ageString = res.patient.clinicalAge ? res.patient.clinicalAge : '--';
        }
        this.recordVersion = res.recordVersion;
        this.patient = res.patient;
        this.orderType = ORDER_TYPE_OPTION.find(it => res.orderType == it.value).label;
        this.fee = res;
        this.records = res.records;
        this.inquiryInfo = res.inquiryInfo;
        // 全部数据
        this.orderPrescriptionList = res.orderPrescriptionList;
        // 是否是全订单优惠
        this.isAllOffer = res.couponDiscountAmt > 0 || res.wipeAmt > 0;
        this.checkDisabled = res.couponDiscountAmt > 0 || res.wipeAmt > 0;
        // 直接售药
        this.salePrescription = res.orderPrescriptionList.filter(item => item.type === 5).map(initChecked);
        // 成药处方
        this.wPrescription = res.orderPrescriptionList.filter(item => item.type === 1).map(initChecked);
        // 中药饮片处方
        this.ePrescription = res.orderPrescriptionList.filter(item => item.type === 2).map(init);
        // 输液卡处方
        this.infusionPrescription = res.orderPrescriptionList.filter(item => item.type === 6).map(initChecked);
        // 贴敷
        this.applyPrescription = res.orderPrescriptionList.filter(item => item.type === 7).map(init);
        this.orderExamList = res.orderExamList.map((item) => {
          const script = cloneDeep(item);
          script.parentChecked = false; // 初始化checked
          script.items = item.items.map((it) => {
            const count = it.count - it.refundedCount;
            return {
              ...it,
              dosage: count,
              maxCount: it.count - it.refundedCount, // 可退货数量
              count: 0, // 退货数量
              checked: false, // 初始化checked
            };
          });
          return script;
        });
        // 附加费用
        this.orderAdditionList = res.orderAdditionList.map((item) => {
          const script = cloneDeep(item);
          script.parentChecked = false; // 初始化checked
          script.items = item.items.map((it) => {
            const count = it.count - it.refundedCount;
            return {
              ...it,
              maxCount: count, // 可退货数量
              count, // 退货数量
              checked: false, // 初始化checked
            };
          });
          return script;
        });
        this.getBalance();
      });
    },
    // 获取支付方式
    getBalance() {
      const orderBalanceList = Object.keys(this.orderBalance);
      this.records.forEach((record) => {
        // 如果是退费就减掉付款方式上的金额
        const def = record.operateType === 2 ? 'minus' : 'plus';
        orderBalanceList.forEach((balance) => {
          const recordBalanceItem = record.recordBalance.find(it => it.payModesLabel === balance);
          if (recordBalanceItem) {
            this.orderBalance[balance] = BN(this.orderBalance[balance])[def](recordBalanceItem.amt).toFixed(3);
          }
        });
      });
    },
    totalPrice(count, price) {
      return BN(price).multipliedBy(count).toFixed(3);
    },
    returd() {
      // 判断退款金额是否为0如果为零不让其退款
      if (isNaN(this.inputAmt) || this.inputAmt < 0) {
        this.$message({
          message: '请输入正确的退款金额!',
          type: 'warning',
        });
        return;
      }
      if (this.isThanAmt) {
        this.$message({
          message: '退费金额超过实收金额!',
          type: 'warning',
        });
        return;
      }
      // 判断有没有退货数量的情况 有的话就让他退
      // console.log(this.hasReturdNum);

      if (!this.hasReturdNum) {
        if (!parseFloat(this.inputAmt) && !this.hasDebtAmt) {
          this.$message({
            message: '请输入退款金额!',
            type: 'warning',
          });
          return;
        }
      }
      // 判断可以单个药品退费的情况然后进行数据过滤
      const drugNumber = (item) => {
        // item 为处方
        const ObjectItem = { id: item.id };
        const drugList = item.items.map((it) => {
          // 判断有没有选中这个药没有选中就在map后面用filter过滤
          if (!it.checked) return false;
          const obj = { id: it.id };
          // 药品是否全退
          // if (it.count === it.maxCount) return obj;
          // console.log(it.count, it.gramCount);
          obj.refundedCount = it.gramCount ? it.count * it.gramCount : it.count;
          obj.actualPrice = it.actualPrice;
          return obj;
        }).filter(it => it);
        // 最新逻辑以上判断都不需要
        ObjectItem.items = drugList;
        return ObjectItem;
      };
      // 初始号 orderItems 防止数据污染
      if (this.req.orderItems) {
        delete this.req.orderItems;
      }
      const salePrice = this.salePrescription.map(drugNumber).filter(drug => drug);
      const wPrice = this.wPrescription.map(drugNumber).filter(drug => drug);
      const inPrice = this.infusionPrescription.map(drugNumber).filter(drug => drug);
      const examPrice = this.orderExamList.map(drugNumber).filter(drug => drug);
      const addPrice = this.orderAdditionList.map(drugNumber).filter(drug => drug);
      const ePrice = this.ePrescription.map(drugNumber).filter(drug => drug);
      const applyPrice = this.applyPrescription.map(drugNumber).filter(drug => drug);
      const orderItems = [
        ...salePrice,
        ...addPrice,
        ...examPrice,
        ...wPrice,
        ...ePrice,
        ...inPrice,
        ...applyPrice,
      ];
      // console.log(orderItems);
      // 判断退款项目中没有单个的药品或者其他的费用
      const hasOnceDrug = orderItems.some(item => item.items);
      this.req.orderId = this.$route.query.id;
      const orderLen = this.salePrescription.length +
                       this.wPrescription.length +
                       this.infusionPrescription.length +
                       this.orderExamList.length +
                       this.orderAdditionList.length +
                       this.ePrescription.length +
                       this.applyPrescription.length;
      // 两个条件进行判断 一个是 是否有items 另一个是 length 是否相等
      // if (hasOnceDrug || orderItems.length !== orderLen) {
      //   this.req.orderItems = orderItems;
      // }
      this.req.orderItems = orderItems;
      // console.log(this.req);
      this.centerDialogVisible = true;
    },
    comfirm() {
      this.comfirmDisabled = true;
      // 是否有欠费
      this.req.recordVersion = this.recordVersion;
      this.req.refundAmt = this.inputAmt;
      [this.req.payMode] = this.payMode;
      this.$api.feeDispense.refund(this.req).then(() => {
        this.centerDialogVisible = false;
        this.comfirmDisabled = false;
        this.$message({
          type: 'success',
          message: '退货成功！',
        });
        this.$router.go(-1);
      }).catch(() => {
        this.centerDialogVisible = false;
        this.comfirmDisabled = false;
      });
    },
    parentCheckHandle(scriptType, checked, index) {
      this[scriptType][index].items = this[scriptType][index].items.map((item, idx) => {
        // 更改药品的数量
        if (checked) {
          this[scriptType][index].items[idx].count = item.maxCount;
        } else {
          this[scriptType][index].items[idx].count = 0;
        }
        if (item.maxCount !== 0) {
          item.checked = checked;
        }

        return item;
      });
      this.resetInputAmt();
    },
    // children checked
    checkHandle(scriptType, checked, index, idx, isInterface, item) {
      // 判断是不是界面操作来的数据
      if (isInterface) {
        if (checked) {
          this[scriptType][index].items[idx].count = item.maxCount;
          // console.log(this[scriptType][index].items[idx].count);
        } else {
          this[scriptType][index].items[idx].count = 0;
        }
      }
      // 如果是选择是false 那个父级的checked 一定为false
      if (!checked) {
        this[scriptType][index].parentChecked = false;
        this.resetInputAmt();
        return;
      }
      const isAll = this[scriptType][index].items.every(it => it.checked === checked);
      if (isAll) this[scriptType][index].parentChecked = checked;
      this.resetInputAmt();
    },
    goBack() {
      this.$router.go(-1);
    },
    // 饮片优惠价计算
    totalSalePriceChinese(item) {
      return BN(item.gramCount).multipliedBy(item.dosage).multipliedBy(item.salePrice).toFixed(3);
    },
    // 饮片原价计算
    totalPriceChinese(item) {
      return BN(item.gramCount).multipliedBy(item.dosage).multipliedBy(item.actualPrice).toFixed(3);
    },
    // 饮片处方数量
    eNum(gramCount, saleUnit, dosage) {
      if (dosage === 1) {
        return gramCount + saleUnit;
      }
      return `${gramCount}${saleUnit}*${dosage}`;
    },
    // 重置input退费金额
    resetInputAmt() {
      this.inputAmt = BN(this.refundAmt).toFixed(2);
    },
    // 小计
    subTotal(receivableAmt, discountAmt) {
      // console.log(receivableAmt, discountAmt);
      return BN(receivableAmt).minus(discountAmt).toFixed(2);
    },
  },
  computed: {
    hasReturdChecked() {
      const hasSaleNum = this.salePrescription.some(item => (item.items.some(it => it.checked)));
      const hasWpNum = this.wPrescription.some(item => (item.items.some(it => it.checked)));
      const hasEpNum = this.ePrescription.some(item => (item.items.some(it => it.checked)));
      const hasApNum = this.applyPrescription.some(item => (item.items.some(it => it.checked)));
      const hasIpNum = this.infusionPrescription.some(item => (item.items.some(it => it.checked)));
      const hasOeNum = this.orderExamList.some(item => (item.items.some(it => it.checked)));
      const hasAdNum = this.orderAdditionList.some(item => (item.items.some(it => it.checked)));
      return !(hasSaleNum
        || hasWpNum
        || hasEpNum
        || hasApNum
        || hasIpNum
        || hasOeNum
        || hasAdNum);
    },
    // 选中的药品是否有退货数量
    hasReturdNum() {
      const hasSaleNum = this.salePrescription.some(item => (item.items.filter(it => it.checked).some(it => it.maxCount > 0)));
      const hasWpNum = this.wPrescription.some(item => (item.items.filter(it => it.checked).some(it => it.maxCount > 0)));
      const hasEpNum = this.ePrescription.some(item => (item.items.filter(it => it.checked).some(it => it.maxCount > 0)));
      const hasApNum = this.applyPrescription.some(item => (item.items.filter(it => it.checked).some(it => it.maxCount > 0)));
      const hasIpNum = this.infusionPrescription.some(item => (item.items.filter(it => it.checked).some(it => it.maxCount > 0)));
      const hasOeNum = this.orderExamList.some(item => (item.items.filter(it => it.checked).some(it => it.maxCount > 0)));
      const hasAdNum = this.orderAdditionList.some(item => (item.items.filter(it => it.checked).some(it => it.maxCount > 0)));
      return hasSaleNum
        || hasWpNum
        || hasEpNum
        || hasApNum
        || hasIpNum
        || hasOeNum
        || hasAdNum;
    },
    // 是不是超过了实付金额
    isThanAmt() {
      // 删除欠费情况
      console.log(this.fee.actualReceivableAmt, this.fee.refundAmt);
      const amt = BN(this.fee.actualReceivableAmt).minus(this.fee.refundAmt).toFixed(2);
      console.log(this.inputAmt, amt);

      return Number(this.inputAmt) > Number(amt);
    },
    favorable() {
      return BN(this.fee.couponDiscountAmt)
        .plus(this.fee.discountAmt)
        .plus(this.fee.wipeAmt)
        .toFixed(2);
    },
    refundAmt() {
      // 支持不退
      const itemsReduce = (a, b) => (a + Number(BN(b.actualPrice).multipliedBy(b.count)));
      // 部分退款
      const add = (a, b) => {
        return a + (Number(b.items.filter(isCheckedChild).reduce(itemsReduce, 0)));
      };
      // 针对饮片的价格计算因为他要乘以贴数
      const itemsReducee = (a, b) => (a + Number(BN(b.actualPrice).multipliedBy(b.count).multipliedBy(b.gramCount)));
      const adde = (a, b) => (a + Number(b.items.filter(isCheckedChild).reduce(itemsReducee, 0)));
      // 附加费用
      const addPrice = this.orderAdditionList.reduce(add, 0);
      // 检查治疗项(可以部分退费)
      const examPrice = this.orderExamList.reduce(add, 0);
      // 直接（可以部分退费）
      const salePrice = this.salePrescription.reduce(add, 0);
      // 成药（可以部分退费）
      const wPrice = this.wPrescription.reduce(add, 0);
      // 饮片
      const ePrice = this.ePrescription.reduce(adde, 0);


      // 输液（可以部分退费）
      const inPrice = this.infusionPrescription.reduce(add, 0);

      // 敷贴是没有数量 总金额是挂在每个处方下面
      const addApply = (a, b) => {
        // if (Number(b.discountAmt) !== 0 && b.parentChecked && !b.isRefunded) {
        //   return a + Number(b.receivableAmt - b.discountAmt);
        // }
        return a + (Number(b.items.filter(isCheckedChild).reduce(itemsReduce, 0)));
      };

      // 敷贴的金额是挂在处方下 所以后台返回refundAmt 告知前端该处方是否退款 如果refundAmt为0那么就是没有退款
      // const isCheckReturn = item => item.parentChecked && !item.refundAmt;
      const applyPrice = this.applyPrescription.reduce(addApply, 0);
      console.log(applyPrice);
      if (BN(addPrice)
        .plus(examPrice)
        .plus(wPrice)
        .plus(ePrice)
        .plus(inPrice)
        .plus(applyPrice)
        .plus(salePrice)
        .toString() === '0') {
        return 0;
      }
      return BN(addPrice)
        .plus(examPrice)
        .plus(wPrice)
        .plus(ePrice)
        .plus(inPrice)
        .plus(applyPrice)
        .plus(salePrice)
        // .minus(this.fee.couponDiscountAmt) // 优惠平摊到每个药品所以不需要前端计算了
        // .minus(this.fee.wipeAmt)
        .toFixed(2);
    },
    debtAmtAfter() {
      if (Number(this.inputAmt) >= this.debtAmtCmpt) {
        return BN(this.inputAmt).minus(this.debtAmtCmpt).toFixed(2);
      }
      return 0;
    },
    debtAmt() {
      if (Number(this.inputAmt) > Number(this.debtAmtCmpt)) {
        return this.debtAmtCmpt;
      }
      return this.inputAmt;
    },
    // 是否有欠费
    hasDebtAmt() {
      return this.orderBalance.debtAmt > 0;
    },
    // 欠费数据整理
    debtAmtCmpt() {
      const orderBalanceList = Object.keys(this.orderBalance);
      let result = 0;
      // 所有欠费金额之和
      this.records.forEach((record) => {
        const recordBalanceItem = record.recordBalance.find(it => it.payModesLabel === 'debtAmt');
        if (recordBalanceItem) {
          result = BN(result).plus(recordBalanceItem.amt).toFixed(2);
        }
      });
      // 其他订单之和
      this.records.forEach((record) => {
        if (record.operateType === 3) {
          orderBalanceList.forEach((balance) => {
            const recordBalanceItem = record.recordBalance.find(it => it.payModesLabel === balance);
            if (recordBalanceItem) {
              result = BN(result).minus(recordBalanceItem.amt).toFixed(2);
            }
          });
        }
        if (record.operateType === 2) {
          const recordBalanceItem = record.recordBalance.find(it => it.payModesLabel === 'refundAmt');
          if (recordBalanceItem) {
            result = BN(result).minus(recordBalanceItem.amt).toFixed(2);
          }
        }
      });
      return result;
    },
  },
  mounted() {
    this.getFeeDetail();
  },
};
